// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimViewModel {
    static getAttributeTypeMap() {
        return ClaimViewModel.attributeTypeMap;
    }
}
ClaimViewModel.discriminator = undefined;
ClaimViewModel.additionalProperties = false;
ClaimViewModel.attributeTypeMap = [
    {
        "name": "claimId",
        "baseName": "claimId",
        "type": "number"
    },
    {
        "name": "parentClaimId",
        "baseName": "parentClaimId",
        "type": "number"
    },
    {
        "name": "createdBy",
        "baseName": "createdBy",
        "type": "number"
    },
    {
        "name": "updatedBy",
        "baseName": "updatedBy",
        "type": "number"
    },
    {
        "name": "claimStatusId",
        "baseName": "claimStatusId",
        "type": "number"
    },
    {
        "name": "dateOfService",
        "baseName": "dateOfService",
        "type": "Date"
    },
    {
        "name": "receivedDate",
        "baseName": "receivedDate",
        "type": "Date"
    },
    {
        "name": "dateProcessed",
        "baseName": "dateProcessed",
        "type": "Date"
    },
    {
        "name": "causeTypeId",
        "baseName": "causeTypeId",
        "type": "number"
    },
    {
        "name": "procedureTypeId",
        "baseName": "procedureTypeId",
        "type": "number"
    },
    {
        "name": "ndc",
        "baseName": "ndc",
        "type": "string"
    },
    {
        "name": "quantity",
        "baseName": "quantity",
        "type": "number"
    },
    {
        "name": "initialCost",
        "baseName": "initialCost",
        "type": "number"
    },
    {
        "name": "initialOutOfPocketAmount",
        "baseName": "initialOutOfPocketAmount",
        "type": "number"
    },
    {
        "name": "benefitPaid",
        "baseName": "benefitPaid",
        "type": "number"
    },
    {
        "name": "remainingCost",
        "baseName": "remainingCost",
        "type": "number"
    },
    {
        "name": "rejectTypeIds",
        "baseName": "rejectTypeIds",
        "type": ""
    },
    {
        "name": "adjudicationCodes",
        "baseName": "adjudicationCodes",
        "type": ""
    },
    {
        "name": "conditions",
        "baseName": "conditions",
        "type": ""
    },
];
//# sourceMappingURL=claimViewModel.js.map